import {zz} from '../../utils/zz';

window.addEventListener('load', async () => {
    const gform = document.querySelector('.gform_wrapper');
    if (!gform) return;
    const module = await import('./gfield');
    module.default();
    await zz(100)
    if (gform.classList.contains('gform_validation_error')) {
        const scroll_y = gform.getBoundingClientRect().top + window.scrollY - 100;
        window.scrollTo({top: scroll_y, behavior: 'smooth'});
    }
});
